import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useMemo, useCallback } from 'react';
import { styled } from '@mui/material';
import MuiBox from '@mui/material/Box';
import { uniq } from 'lodash';
import { FilterPopover } from '../common/FilterPopover.js';
import InputField from '../common/InputField.js';
import FilterCheckboxListField from './FilterCheckboxListField.js';

const _FilterPopover = styled(FilterPopover) `
  padding: ${({ theme }) => theme.spacing(1)};
`;
const CheckboxListWrapper = styled(MuiBox) `
  overflow-y: scroll;
  max-height: 100px;
  flex-wrap: nowrap;
`;
const CheckboxListFilter = ({ column, rows, placeholder, preFilteredRows, accessor }) => {
    const [searchValue, setSearchValue] = useState('');
    const values = useMemo(() => {
        const uniqPreFilteredRows = uniq(preFilteredRows.map(({ original }) => original[accessor]));
        const currentCheckedValues = rows.map(({ original }) => original[accessor]);
        return uniqPreFilteredRows.map(value => {
            const checked = currentCheckedValues.includes(value);
            return { label: value, name: value, checked };
        });
    }, [accessor, preFilteredRows, rows]);
    const onIntervalChange = useCallback((values) => {
        const value = values.filter(({ checked }) => checked).map(({ label }) => label);
        column.setFilter({ value });
    }, [column]);
    return (jsxs(_FilterPopover, { children: [jsx(InputField, { placeholder: placeholder, onChange: setSearchValue }), jsx(CheckboxListWrapper, Object.assign({ className: "styled-scrollbar" }, { children: jsx(FilterCheckboxListField, { options: values, onSelectionChange: onIntervalChange, searchValue: searchValue }) }))] }));
};

export { CheckboxListFilter, CheckboxListFilter as default };
//# sourceMappingURL=CheckboxListFilter.js.map
